<template>
    <div id="content">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
            <h1>{{ entity.name }}</h1>
        </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
            <detail-entity-info
                :entity="entity"
                :omit-default="['id_remote']"
            >
            </detail-entity-info>
            </div>
            <div class="right">
              <div class="field_left">
                <text-input id="currencyname"
                            :required="true"
                            v-model="entity.name"
                            :disabled="true"
                            ref="nameref"
                >
                  <translate class="translate">Název</translate>
                </text-input>
              </div>
              <div class="field_right">
                <text-input id="currencysymbol"
                            :required="true"
                            v-model="entity.symbol"
                            :disabled="true"
                            ref="symbolref"
                >
                  <translate class="translate">Jednotka</translate>
                </text-input>
              </div>
              <div class="field_left">
                <text-input id="currencyformatstring"
                            :required="true"
                            v-model="entity.format_string"
                            :disabled="true"
                            ref="formatstringref"
                >
                  <translate class="translate">Formátování</translate>
                </text-input>
              </div>
            </div>
          </section>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
            </p>
          </section>
        </div>
      </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import DetailEntityInfo from "../../common/DetailEntityInfo.vue";

export default {
    name: "VodVideosDetail",
  components: {DetailEntityInfo},
    mixins: [
        detailActions,
    ],
    data() {
        return {
            entityName: "currency",
            moduleName: "currencies",
            loading: true,
        }
    },
    created(CurrencyService) {
        this.entityService = CurrencyService
        this.createdInit()
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/currencies/CurrenciesDetail.vue